import { Button } from 'antd';
import { NotificationsOutlinedIcon } from 'common/icons';
import { useTranslation } from 'react-i18next';
import { GreenColors } from 'theme';

import * as Styled from './notification-toast.style';

interface NotificationToastProps {
  title: string;
  description: string;
  onView?: () => void;
  onDismiss?: () => void;
}

const NotificationToast = ({
  title,
  description,
  onView,
  onDismiss,
}: NotificationToastProps) => {
  const { t } = useTranslation();

  return (
    <Styled.ToastWrapper>
      <Styled.ToastIconWrapper>
        <NotificationsOutlinedIcon style={{ width: 20, height: 20 }} />
      </Styled.ToastIconWrapper>
      <Styled.ToastBody>
        <Styled.ToastTitle>{title}</Styled.ToastTitle>
        <Styled.ToastDescription>{description}</Styled.ToastDescription>
        <Styled.ToastActions>
          {onDismiss && (
            <Button size="small" type="text" onClick={onDismiss}>
              {t('buttons.dismiss')}
            </Button>
          )}
          {onView && (
            <Button
              style={{ backgroundColor: GreenColors[60] }}
              size="small"
              type="primary"
              onClick={onView}
            >
              {t('buttons.view')}
            </Button>
          )}
        </Styled.ToastActions>
      </Styled.ToastBody>
    </Styled.ToastWrapper>
  );
};

export { NotificationToast };
